<form class="product-search-form">
  <mat-form-field
    appearance="outline"
    floatLabel="auto"
    subscriptSizing="dynamic"
    class="no-border"
  >
    <input
      matInput
      #autoCompleteTextInput
      [matAutocomplete]="auto"
      [placeholder]="translationService.getSearchForAProductText()"
      [formControl]="searchControl"
      (keydown.enter)="gotoSearchPage()"
    />
    <mat-icon matPrefix>search</mat-icon>
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayName"
      color="primary"
      hideSingleSelectionIndicator="true"
      class="blue-search-autocomplete"
      (optionSelected)="onSelectionChanged($event)"
    >
      @for (product of filteredOptions | async; track product) {
        <mat-option [value]="product.id">
          <mat-icon>chevron_right</mat-icon>
          <div class="search-row">
            <span class="white-highlight-select">{{ product.name }}</span>
            <span class="white-highlight-select">{{ product.brand }}</span>
            @if (product.supplier) {
              <span class="white-highlight-select">{{ product.supplier }}</span>
            }
          </div>
        </mat-option>
      } @empty {
        <mat-option value="null">{{
          translationService.getNoResultsText()
        }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
